import React from 'react'
import AuthStore from '../stores/AuthStore'
import CommonStore from '../stores/CommonStore';

export const storesContext = React.createContext({
    AuthStore: AuthStore,
    CommonStore: CommonStore,
});
